import { getSessionAuthentication } from '../common/Api';

const rms2BasePath = process.env.RMS2_BASE_PATH ?? '';

interface FetchOptions {
    method: string;
    headers: Record<string, string>;
    body?: string;
}

function getHeaders(): Record<string, string> {
    const auth = getSessionAuthentication();
    return {
        'Content-Type': 'application/json',
        'Authorization': auth.token,
        'x-cleverapps-tenant': auth.tenantStringIdentifier,
    };
}

async function rms2Fetch<T>(path: string, options?: Partial<FetchOptions>): Promise<T> {
    const response = await fetch(rms2BasePath + path, {
        method: options?.method ?? 'GET',
        headers: getHeaders(),
        body: options?.body,
    });
    if (!response.ok) {
        const text = await response.text();
        let message = `API error: ${response.status} ${response.statusText}`;
        try {
            const parsed = JSON.parse(text);
            if (parsed?.message) message = parsed.message;
        } catch { /* ignore */ }
        throw new Error(message);
    }
    const text = await response.text();
    return text ? JSON.parse(text) : null;
}

export interface CustomerGroup {
    id: number;
    code: string;
    name: string;
}

export async function getCustomerGroup(id: number): Promise<CustomerGroup> {
    return rms2Fetch<CustomerGroup>(`customergroups/${id}`);
}

export async function createCustomerGroup(cg: Partial<CustomerGroup>): Promise<CustomerGroup> {
    return rms2Fetch<CustomerGroup>('customergroups', {
        method: 'POST',
        body: JSON.stringify(cg),
    });
}

export async function updateCustomerGroup(cg: CustomerGroup): Promise<CustomerGroup> {
    return rms2Fetch<CustomerGroup>(`customergroups/${cg.id}`, {
        method: 'PUT',
        body: JSON.stringify(cg),
    });
}

export async function deleteCustomerGroup(id: number): Promise<void> {
    await rms2Fetch<void>(`customergroups/${id}`, { method: 'DELETE' });
}
